import { useForm, SubmitHandler, Resolver } from 'react-hook-form';
import { useGetPrizeIdQuery, useUpdatePrizeIdMutation } from 'entities/prize/api';
import { PrizeFormType, validationSchema } from 'entities/prize/model';
import { useParams } from 'react-router-dom';
import { useUpdatePrizeCardDefaultValues } from 'entities/prize/lib';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { toast } from 'react-toastify';
import { PrizeForm } from './PrizeForm';

export const UpdatePrizeForm = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { data: prizeId } = useGetPrizeIdQuery({ id });
  const [updatePrizeRequest] = useUpdatePrizeIdMutation();

  const defaultValues = useUpdatePrizeCardDefaultValues(prizeId!);
  const updatePrizeForm = useForm<Partial<PrizeFormType>>({
    resolver: yupResolver(validationSchema) as Resolver<Partial<PrizeFormType>>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<Partial<PrizeFormType>> = (data) => {
    updatePrizeRequest({ data, id }).then((res: any) => {
      dispatch(setDrawerOpen(false));
      if (data.prize_file && !res.error) {
        toast.success('Файл успешно сохранен', {
          position: toast.POSITION.TOP_RIGHT,
        });
        window.open('/downloads/tables-code', '_blank');
      }
    });
  };

  // @ts-ignore TODO refactor
  return (
    <PrizeForm
      form={updatePrizeForm}
      onSubmit={onSubmit}
      textButton="Изменить"
    />
  );
};
